<div class="box skeleton">
    <div class="bone edit-button"></div>
    <div class="bone saved-filter saved-filter_1"></div>
    <div class="bone saved-filter saved-filter_2"></div>
    <div class="bone saved-filter saved-filter_3"></div>
</div>